


















































































import {
    defineComponent,
    onMounted,
    reactive,
    toRefs,
    computed
} from '@vue/composition-api';
import { Toast } from '@kibt/meta-ui';
import { useClipboard } from '@/common/use-clipboard';
import { isAndroid } from '@/common/device-info';
import { callApp } from '@/common/call-app';
import { sendLog, immediateSendLog, webLogger } from '@/common/log';
import imageBox from '@/components/image-box/index.vue';
import threshold from '@/components/threshold/index.vue';
import { format } from '@/common/foramt-invite-code';
import { appFullNameMap, countryPlatform, COUNTRY_LIST, webLanguage, webCountry } from '@/common/const';
import { toLocaleString } from '@/common/util';
import { inviteShareData, fetchData } from './model';
import { getMessagesByCountry, getMessagesById } from '../invitation/model';
import { getLocale, getFishLangCode } from '@/config/language';


export default defineComponent({
    components: {
        imageBox,
        threshold,
    },
    filters: {
        format,
    },
    setup(props, ctx) {
        const boostMessages: any = reactive({
            backgroundColor: '',
            backgroundImage: '',
            boostCode: '',
            button: '',
            canBoostButton: '',
            canBoostDesc: '',
            copyButton: '',
            copyToast: '',
            ended: '',
            finished: '',
            inviteTitle: '',
            step1: '',
            step2: '',
            step3: '',
            title: '',
            titlePaddingText: '',
            unit: '',
            userFinishedDesc: '',
            userInviteDescription: '',
        });
        const { cc, activity, fishId, share_id, sourcePlatform, countryInfo: countryName, share_uid,
            userId, share_item_type, share_device_id, language } = ctx.root.$route?.query;
        const userID = userId || share_uid;
        const country = Array.isArray(countryName) ? countryName[0] : countryName;
        const countryInfo = (country as string)?.toLowerCase();

        const shareIds = share_id?.toString().split('_') ?? [];
        const languageCode = language as string || '';
        immediateSendLog({
            type: 'pv',
            name: 'HELP_INVITE_OUTH5',
            value: {
                type: isAndroid ? 'ANDROID' : 'IOS',
                share_channel: cc,
                share_activity: activity,
                share_id,
                fish_id: fishId,
                ua: window.navigator.userAgent,
                source_platform: sourcePlatform,
                share_item_info: 'refferalactivitydefault', // 非枚举文本型,分享内容id
                share_uid: userID, // 非枚举文本型,分享用户id
                share_item_type, // 非枚举文本型,分享业务类型
                share_timestamp: shareIds[shareIds?.length - 1], // 非枚举文本型,分享的时间戳
                share_device_id, // 非枚举文本型,分享者的did
                isBusinessCoreLog: true,
            },
        });

        const appName = countryPlatform[countryInfo as COUNTRY_LIST] || 'pro';
        const appFullName = appFullNameMap[appName];
        const isSnack = appName === 'snack';

        const state = reactive({
            isTouch: true,
            backgroundImage: '',
            backgroundColor: '',
            positionList: [],
            // 每次pv复制成功只上报一次success
            hasCopied: false,
            inviteDescription: '',
        });

        // const inviteShareModel = useApolloModel(InviteShareModel);

        const pointList = computed(() => {
            // 读取位置信息
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            state.positionList = inviteShareData.awardList.map((_, index) => index * 100) as [];

            return inviteShareData.isGolds ? inviteShareData.awardList : inviteShareData.awardList.map((val) => val / 100);
        });

        // 真实最大值
        const maxRealValue = computed(() => {
            return inviteShareData.awardList[inviteShareData.awardList?.length - 1] as number;
        });

        const isReachMax = computed(() => {
            return inviteShareData.reward as number >= maxRealValue.value;
        });

        const cashFormat = (value: number) => {
            if (!value) {return;}
            return inviteShareData.isGolds
                ? `${toLocaleString(value)} ${boostMessages.unit}`
                : `${inviteShareData.unit} ${toLocaleString(value / 100)}`;
        };

        // 手动触发绑定邀请码
        const handleInviteCodeCopy = (isCallApp?: Boolean) => {
            if ((isCallApp || state.isTouch) && ctx.refs.copyButton) {
                state.isTouch = false;
                (ctx.refs.copyButton as HTMLElement).click();
            }
        };

        const handleCallAppClick = () => {
            if (isReachMax.value) {return;}
            sendLog({
                type: 'click',
                name: 'HELP',
                value: {
                    isBusinessCoreLog: true,
                },
            });

            handleInviteCodeCopy(true);

            let query: Record<string, any> = {
                webview: 'yoda',
                showLoading: 'true',
                needLogin: 'true',
                need_login: 'true',
                source: 'OUT_APP',
                inviteCode: inviteShareData.inviteCode || '',
                hyId: 'incentive_main',
                countryInfo: country,
                loginCheck: 1,
                __login_params__: JSON.stringify({ scheme: 'ikwai://login', loginType: 1 }),
                __launch_options__: JSON.stringify({ topBarPosition: 'fixed', enableLoading: true, loadingType: 'incentive_h5' }),
            };

            if (isSnack) {
                query = {
                    ...query,
                    hideNavBar: 1,
                };
            }

            const search = Object.entries(query).map(([key, value]) => `${key  }=${  encodeURIComponent(value)}`).join('&');

            // todo: 目前跳转回测试环境任务中心，上线时改回线上环境
            const url = `${window.location.origin}/activity/boost?${search}`;

            // const url = `https://incentive.kwai.com/activity/boost?${search}`;

            const protocol = isSnack ? 'ikwaibulldog' : 'ikwai';
            const onlink = {
                me: 'https://kwaime.onelink.me/V16i/boost',
                pro: 'https://go.onelink.me/iGO2/boost',
                snack: 'https://snackinvitation.onelink.me/gUpo/boost',
            };

            const afSub1 = JSON.stringify({
                share_id,
                shareInfo: {
                    target_url: location.href,
                },
            });

            callApp({
                // 拉活归因链路中必需参数 调起客户端时 客户端会检测链接中是否有target_url参数
                path: `webview?url=${encodeURIComponent(url)}&target_url=${encodeURIComponent(location.href)}`,
                onelink: `${onlink[appName]}?af_sub1=${encodeURIComponent(afSub1)}`,
                protocol,
            });
        };

        useClipboard({
            target: '.invite-code-button',
            clipboardOption: {
                text: () => inviteShareData.inviteCode,
            },
            successCallback: () => {
                Toast.show({
                    text: boostMessages.copyToast,
                });
                if (state.hasCopied) {
                    return;
                }
                state.hasCopied = true;
                sendLog({
                    type: 'click',
                    name: 'COPY_SUCCESS',
                });
            },
            errorCallback: () => {
                sendLog({
                    type: 'click',
                    name: 'COPY_FAIL',
                });
            },
        });
        const getPreivewMessage = (name: string) => {
            const pageMap: Record<string, string> = {
                '/activity/invite-share': 'inviteShare',
                '/activity/share-invitation': 'inviteShare',
                '/activity/boost-share-invitation': 'landing',
            };
            const search = new URLSearchParams(location.search);
            const sharePageType = search.get('sharePageType') as string;
            const messageName = pageMap[name];
            const messageStr = decodeURIComponent(search.get(messageName) as string);
            try {
                const message = JSON.parse(messageStr);
                const pageTypeNum = +sharePageType;
                if (message){
                    if (pageTypeNum && messageName === 'inviteShare') {
                        message[`experiment-${pageTypeNum}`] = { ...message};
                    }
                    return message;
                }
                return {};
            } catch (error) {
                return {};
            }
        };
        const initPreviewPage = (messages: any = {}) => {
            const previewPage = ['/activity/boost-share-invitation', '/activity/share-invitation', '/activity/invite-share'];
            let previewMessage: any;
            if (previewPage.includes(location.pathname)) {
                previewMessage = getPreivewMessage(location.pathname);
                messages = Object.assign(messages, previewMessage);
            }
            return {
                landing: messages,
            };
        };
        // 获取落地页样式和素材
        const getShareMessages = async () => {
            let messagesRes:any;
            if (fishId && /^\d+$/.test(String(fishId))) {
                messagesRes = await getMessagesById({
                    fishId: Number(fishId),
                    language: getLocale(),
                    pageName: 'landing',
                });
            } else {
                messagesRes = await getMessagesByCountry({
                    path: window.location.pathname,
                    language: languageCode || getFishLangCode(webLanguage),
                    country: webCountry,
                });
            }

            try {
                webLogger?.plugins?.radar?.fmp();
            } catch (error) {
                console.error(error);
            }
            messagesRes = initPreviewPage(messagesRes.landing);
            boostMessages.title = messagesRes.landing.backgroundColor;
            boostMessages.backgroundColor = messagesRes.landing.backgroundColor;
            boostMessages.backgroundImage = messagesRes.landing.backgroundImage;
            boostMessages.boostCode = messagesRes.landing.boostCode;
            boostMessages.button = messagesRes.landing.button;
            boostMessages.canBoostButton = messagesRes.landing.canBoostButton;
            boostMessages.canBoostDesc = messagesRes.landing.canBoostDesc;
            boostMessages.copyButton = messagesRes.landing.copyButton;
            boostMessages.copyToast = messagesRes.landing.copyToast;
            boostMessages.ended = messagesRes.landing.ended;
            boostMessages.finished = messagesRes.landing.finished;
            boostMessages.inviteTitle = messagesRes.landing.inviteTitle;
            boostMessages.step1 = messagesRes.landing.step1;
            boostMessages.step2 = messagesRes.landing.step2;
            boostMessages.step3 = messagesRes.landing.step3;
            boostMessages.title = messagesRes.landing.title;
            boostMessages.titlePaddingText = messagesRes.landing.titlePaddingText;
            boostMessages.unit = messagesRes.landing.unit;
            boostMessages.userFinishedDesc = messagesRes.landing.userFinishedDesc;
            boostMessages.userInviteDescription = messagesRes.landing.userInviteDescription;
            document.title = boostMessages.title as string;
            state.backgroundImage = boostMessages.backgroundImage as string;
            state.backgroundColor = boostMessages.backgroundColor as string;
            state.inviteDescription = boostMessages.canBoostDesc.
                replace(new RegExp('{username}', 'g'), inviteShareData.nickName).
                replace(new RegExp('{reward}', 'g'), cashFormat(inviteShareData.activityReward) ).
                replace(new RegExp('{appName}', 'g'), appFullName);
        };

        onMounted(async () => {

            await fetchData({
                userId: ctx.root.$route.query.userId || ctx.root.$route.query.share_uid,
            });

            await getShareMessages();

            let status = '';
            if (inviteShareData.isEnded) {
                status = 'ACTIVITY_END';
            } else {
                status = isReachMax.value ? 'HELPED' : 'CAN_HELP';
            }

            sendLog({
                type: 'show',
                name: 'PAGE_STATUS',
                value: {
                    status,
                    isBusinessCoreLog: true,
                },
            });

            (window as any).addEventListener('scroll', () => handleInviteCodeCopy());
        });

        return {
            ...toRefs(state),
            handleCallAppClick,
            handleInviteCodeCopy,
            pointList,
            isReachMax,
            appFullName: appFullName ?? '',
            cashFormat,
            inviteShareData,
            boostMessages,
        };
    },
});
